import { render, staticRenderFns } from "./edit-form.vue?vue&type=template&id=63f6148a&scoped=true&"
import script from "./edit-form.vue?vue&type=script&lang=js&"
export * from "./edit-form.vue?vue&type=script&lang=js&"
import style0 from "./edit-form.vue?vue&type=style&index=0&id=63f6148a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63f6148a",
  null
  
)

export default component.exports